'use client';

import { useEffect, useState } from 'react';
import AboutLPCtaButton from 'components/v2/modules/about-lp/cta-button';

const HeroSection = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <>
      <style jsx>{`
        @keyframes fadeInScale {
          from {
            opacity: 0;
            transform: scale(0.95) translateY(20px);
          }
          to {
            opacity: 1;
            transform: scale(1) translateY(0);
          }
        }

        @keyframes slideUpFromBottom {
          from {
            opacity: 0;
            transform: translateY(60px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .hero-title {
          opacity: 1;
          transform: translateY(0);
          transition: all 0.8s cubic-bezier(0.16, 1, 0.3, 1);
        }

        .hero-title:not(.loaded) {
          opacity: 0;
          transform: translateY(60px);
        }

        .hero-description {
          opacity: 1;
          transform: translateY(0);
          transition: all 0.8s cubic-bezier(0.16, 1, 0.3, 1);
          transition-delay: 0.2s;
        }

        .hero-description:not(.loaded) {
          opacity: 0;
          transform: translateY(60px);
        }

        .hero-cta {
          opacity: 1;
          transform: translateY(0);
          transition: all 0.8s cubic-bezier(0.16, 1, 0.3, 1);
          transition-delay: 0.4s;
        }

        .hero-cta:not(.loaded) {
          opacity: 0;
          transform: translateY(60px);
        }
      `}</style>
      <section
        id="hero-section"
        className="relative flex min-h-[60vh] items-center justify-center overflow-hidden p-12"
      >
        {/* Background overlay */}
        <div
          className="absolute inset-0 size-full opacity-30"
          style={{
            filter: 'blur(0.5px)',
            backgroundImage: 'url(/images/about/about-careers-bg.jpg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        />
        {/* Hero Content */}
        <div className="relative z-10 mx-auto flex max-w-5xl items-center justify-center">
          <div className="max-w-3xl rounded-2xl bg-white px-6 py-10 text-center shadow-xl">
            <h1
              className={`hero-title ${isLoaded ? 'loaded' : ''} my-0 text-4xl font-black leading-[1.1] tracking-tight text-pp-text-primary md:text-6xl md:leading-[1.1]`}
            >
              PostPrimeとは
            </h1>
            <p
              className={`hero-description ${isLoaded ? 'loaded' : ''} mt-6 text-xl leading-relaxed text-pp-text-secondary md:text-2xl`}
            >
              お金と投資の情報プラットフォーム
            </p>
            <p
              className={`hero-description ${isLoaded ? 'loaded' : ''} mt-4 text-base leading-relaxed text-pp-text-secondary md:text-lg`}
            >
              専門家と投資家が集まり、質の高い情報を共有し合う新しいSNSプラットフォームです
            </p>
            <div className={`hero-cta ${isLoaded ? 'loaded' : ''} mt-8`}>
              <AboutLPCtaButton
                text="今すぐ始める"
                type="greenWithArrow"
                href="/"
                position="hero"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HeroSection;
